<div class="search-wrapper" (blur)="hadText=false">
  <div class="input-group input-group-sm" style="min-width: 400px;">
    <input #dashModuleSearch
      type="text" autocomplete="off"
      [style.caretColor]="accentColor"
      class="form-control editable"
      [placeholder]="placeholderText"
      [(ngModel)]="searchText"
      (keyup.escape)="(dashModuleSearch.value.length) ? clearEvent() : null"
      (keyup.arrowdown)="moveSelectionDown()"
      (keyup.arrowup)="moveSelectionUp()"
      (keyup)="processKeyEvent($event)"
      aria-label="Search" aria-describedby="basic-addon2">
    <div class="input-group-append">
      <button class="btn btn-outline-primary"
        [matTooltipShowDelay]="tooltipDelay"
        [matTooltip]="!hadText ? 'Show List' : 'Hide List'"
        name="basic-addon3"
        *ngIf="allDataDropdown"
        type="button" (click)="openDropdown()"
        (keyup.arrowup)="moveSelectionUp()"
        (keyup.arrowdown)="moveSelectionDown()"
        (keyup.enter)="processKeyEvent($event)">
        <i class="fal" [ngClass]="{'fa-chevron-square-down': !hadText, 'fa-chevron-square-up': hadText}"></i>
      </button>
      <button *ngIf="!selectionMode"
        class="btn btn-outline-primary"
        name="basic-addon2"
        [disabled]="dashModuleSearch.value.length < 2"
        type="button" (click)="searchEvent(dashModuleSearch.value)">
        <i class="fal fa-search"></i>
      </button>
      <button class="btn" *ngIf="!configLocked"
        [ngClass]="{'btn-outline-secondary': !configureMode, 'btn-secondary active': configureMode}"
        name="basic-addon1" [popover]="defaultConfiguration"
        popoverTitle="Refine search fields"
        [outsideClick]="true"
        [matTooltipShowDelay]="tooltipDelay"
        [matTooltip]="configLocked ? 'Search settings are disabled here' : 'Toggle search settings'"
        type="button" [disabled]="configLocked">
        <i [class]="'fal ' + configIcon"></i>
      </button>
    </div>
  </div>
  <div *ngIf="dropDown">
    <ng-container *ngTemplateOutlet="defaultDataDropdown"></ng-container>
  </div>
  <div *ngIf="configureMode">
    <ng-container *ngTemplateOutlet="defaultConfiguration"></ng-container>
  </div>
</div>

<ng-template #defaultConfiguration>
  <div class="" [style.z-index]="zIndex">
    <div class="container">
      <div class="row" *ngFor="let f of modularSearchFields">
        <div class="col-8">
          <label class="fieldLabel" [for]="'sc' + f.fieldName">{{ f.displayName }}</label>
        </div>
        <div class="col">
          <label class="switch">
            <input [id]="'sc' + f.fieldName" type="checkbox" (change)="searchEvent(dashModuleSearch.value)" [(ngModel)]="f.enabled">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #defaultDataDropdown>
  <div *ngIf="hadText">
    <div *ngIf="dataToShow.length > 0; else noResults" class="search-dropdown">
    </div>
    <ng-template #noResults>
      <div class="search-dropdown no-results">
        No results.
      </div>
    </ng-template>
  </div>
</ng-template>
